import { NoteReceivable } from '../../generated/graphql';
import { FC, createContext, useContext } from 'react';

interface NoteReceivableFormContextProps {
  householdID: string;
  children?: React.ReactNode;
  noteReceivable: NoteReceivable | undefined | null;
}

interface NoteReceivableFormContext extends Omit<NoteReceivableFormContextProps, 'children'> {}

const NoteReceivableFormContext = createContext<NoteReceivableFormContext | null>(null);

export const useNoteReceivableFormContext = () => {
  const context = useContext(NoteReceivableFormContext);

  if (!context) {
    throw new Error('Make sure to use the NoteReceivableFormContext inside of the provider');
  }
  return context;
};

export const NoteReceivableFormContextProvider: FC<NoteReceivableFormContextProps> = ({ children, ...props }) => {
  return <NoteReceivableFormContext.Provider value={props}>{children}</NoteReceivableFormContext.Provider>;
};
